import * as Constants from "../../constants/urls";
import React, { Fragment, useEffect, useState } from "react";
import Header from "../Header/Header";
import { Drawer } from "@mui/material";
import RightMenu from "../Header/RightMenu";
import Alerts from "../Alerts";
import axios from "axios";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

function TaskTime() {

    const [state, setState] = useState({ right: false });

    const [data, setData] = useState(undefined);

    const [pick, setPick] = useState("");
    const [pack, setPack] = useState("");
    const [check, setCheck] = useState("");
    const [chidan, setChidan] = useState("");

    const [cookies, setCookie, removeCookie] = useCookies();

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };


    useEffect(() => {
        const url = Constants.apiUrl + `/api/task-time/get`;
        axios
            .get(
                `${url}`,

                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((response) => {
                setData(response.data);
                setChidan(response.data.chidan_score)
                setPick(response.data.pick_score)
                setPack(response.data.pack_score)
                setCheck(response.data.check_score)
            })
            .catch((error) => {
                toast.error("خطایی رخ داد")
            });
    }, [])



    const submit = async () => {
        const url = Constants.apiUrl + `/api/task-time/update`;
        await axios
            .post(
                `${url}`,
                {
                    pick_score: pick,
                    pack_score: pack,
                    check_score: check,
                    chidan_score: chidan,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((response) => {
                toast.success("با موفقیت ذخیره شد")
            })
            .catch((error) => {
                toast.error("خطایی رخ داد")
            });
    };
    return (
        <Fragment>
            <Breadcrumb title={"  زمان فعالیت های انبار  "} />

            <div
                className="container my-4"
                style={{
                    padding: "25px",
                    borderRadius: "15px",
                    border: "1px solid rgb(219, 219, 219)",
                }}
            >
                <span className="text-center  text-success mb-4" style={{ display: "grid" }}>
                    زمان های مورد نظر خود را بر حسب ثانیه وارد کنید
                </span>
                <hr />

                <div className="row">

                    <div className=" col-sm-6 text-center">
                        <span className="d-inline-block">پیک</span>
                        <input
                            tabIndex={1}
                            type="text"
                            className="form-control d-inline-block"
                            onChange={(e) => setPick(e.target.value)}
                            value={pick}
                        />
                    </div>
                    <div className="col-sm-6 text-center">
                        <span className="d-inline-block"> بسته بندی</span>
                        <input
                            tabIndex={2}
                            type="text"
                            className="form-control d-inline-block"
                            onChange={(e) => setPack(e.target.value)}
                            value={pack}
                        />
                    </div>
                    <div className="col-sm-6 text-center">
                        <span className="d-inline-block">چیدن</span>
                        <input
                            tabIndex={3}
                            type="text"
                            className="form-control d-inline-block"
                            onChange={(e) => setChidan(e.target.value)}
                            value={chidan}
                        />
                    </div>
                    <div className="col-sm-6 text-center">
                        <span className="d-inline-block">چک</span>
                        <input
                            tabIndex={4}
                            type="text"
                            className="form-control d-inline-block"
                            onChange={(e) => setCheck(e.target.value)}
                            value={check}
                        />
                    </div>
                    <div className="col mt-4">
                        <button
                            tabIndex={3}
                            className="btn btn-block btn-success"
                            onClick={submit}
                        >
                            اعمال{" "}
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default TaskTime;
